import * as React from "react";
import {
    List,
    Datagrid,
    TextField,
    EditButton,
    Edit,
    Create,
    SimpleForm,
    TextInput,
    SelectInput,
    NumberInput,
    BooleanInput,
    DateField,
    Filter,
    ReferenceInput,
    ReferenceField,
    DeleteButton,
} from 'react-admin';

const ResourceFilter = (props) => (
    <Filter {...props}>
        <ReferenceInput source="CourseId" reference="Admin/CMSCourse" label="课程" alwaysOn>
            <SelectInput optionText="Title" />
        </ReferenceInput>
        <SelectInput source="Type" label="类型" choices={[
            { id: 'video', name: '视频' },
            { id: 'doc', name: '文档' },
            { id: 'audio', name: '音频' },
        ]} />
    </Filter>
);

export const CourseResourceList = props => (
    <List {...props} filters={<ResourceFilter />} title="课程资料管理">
        <Datagrid rowClick="edit">
            <TextField source="id" />
            <TextField source="Title" label="资料标题" />
            <ReferenceField source="CourseId" reference="Admin/CMSCourse" label="所属课程" allowEmpty>
                <TextField source="Title" />
            </ReferenceField>
            <TextField source="Type" label="类型" />
            <TextField source="Duration" label="时长(秒)" />
            <TextField source="Sort" label="排序" />
            <TextField source="IsFree" label="试看" />
            <DateField source="CreateTime" label="创建时间" showTime />
            <EditButton />
            <DeleteButton />
        </Datagrid>
    </List>
);

export const CourseResourceEdit = props => (
    <Edit {...props} title="编辑资料">
        <SimpleForm>
            <TextInput disabled source="id" />
            <ReferenceInput source="CourseId" reference="Admin/CMSCourse" label="所属课程">
                <SelectInput optionText="Title" />
            </ReferenceInput>
            <TextInput source="Title" label="资料标题" fullWidth />
            <SelectInput source="Type" label="类型" choices={[
                { id: 'video', name: '视频' },
                { id: 'doc', name: '文档' },
                { id: 'audio', name: '音频' },
            ]} />
            <TextInput source="Url" label="资源URL" fullWidth />
            <NumberInput source="Duration" label="时长(秒)" />
            <NumberInput source="FileSize" label="文件大小(字节)" />
            <NumberInput source="Sort" label="排序" />
            <BooleanInput source="IsFree" label="允许试看" />
        </SimpleForm>
    </Edit>
);

export const CourseResourceCreate = props => (
    <Create {...props} title="新建资料">
        <SimpleForm>
            <ReferenceInput source="CourseId" reference="Admin/CMSCourse" label="所属课程">
                <SelectInput optionText="Title" />
            </ReferenceInput>
            <TextInput source="Title" label="资料标题" fullWidth />
            <SelectInput source="Type" label="类型" defaultValue="video" choices={[
                { id: 'video', name: '视频' },
                { id: 'doc', name: '文档' },
                { id: 'audio', name: '音频' },
            ]} />
            <TextInput source="Url" label="资源URL" fullWidth />
            <NumberInput source="Duration" label="时长(秒)" defaultValue={0} />
            <NumberInput source="FileSize" label="文件大小(字节)" defaultValue={0} />
            <NumberInput source="Sort" label="排序" defaultValue={0} />
            <BooleanInput source="IsFree" label="允许试看" defaultValue={false} />
        </SimpleForm>
    </Create>
);
